let priceCache = null;
let priceRequest = null;

export const pricingPlans = [
    {
        title: 'Free',
        price: 0,
        priceId: '0',
        features: [
            '100 searches per month',
            'Subreddit trends so that you can find the 💡 that you\'re looking for',
        ],
        isPopular: false,
    },

    {
        title: 'Pro',
        price: '$9.99', // Default while fetching
        // Use the environment variable for the Pro subscription price ID
        priceId: process.env.REACT_APP_STRIPE_PRICE_ID,
        features: [
            'Unlimited searches per month',
            'Subreddit trends so that you can find the 💡 that you\'re looking for',
            'AI suggestions',
        ],
        isPopular: true,
    }
];

export const PRICING_ERROR_MESSAGE =
    'Pricing is temporarily unavailable. Please try again.';

const isRecord = (value) =>
    value !== null && typeof value === 'object' && !Array.isArray(value);

const requireText = (value, fieldName) => {
    if (typeof value !== 'string' || value.trim().length === 0) {
        throw new TypeError(`Pricing ${fieldName} must be a non-empty string`);
    }

    return value.trim();
};

const parseProPrice = (payload) => {
    if (!isRecord(payload)) {
        throw new TypeError('Pricing response must be an object');
    }

    const priceId = requireText(payload.priceId, 'priceId');
    const currency = requireText(payload.currency, 'currency').toUpperCase();
    const productName = requireText(payload.productName, 'productName');

    if (!Number.isInteger(payload.amount) || payload.amount <= 0) {
        throw new TypeError('Pricing amount must be a positive integer');
    }
    if (!/^[A-Z]{3}$/.test(currency)) {
        throw new TypeError('Pricing currency must be a three-letter code');
    }
    if (payload.interval !== 'month') {
        throw new TypeError('Pricing interval must be monthly');
    }

    return { priceId, amount: payload.amount, currency, productName };
};

const formatPrice = ({ amount, currency }) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
    });
    const fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
    return formatter.format(amount / (10 ** fractionDigits));
};

const loadProPrice = async () => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/api/v1/get-pricing`
        );

        if (!response.ok) {
            throw new Error(`Pricing request failed with status ${response.status}`);
        }

        const proPrice = parseProPrice(await response.json());
        const formattedPrice = formatPrice(proPrice);
        const proTierPlan = pricingPlans.find((plan) => plan.title === 'Pro');
        if (proTierPlan) {
            proTierPlan.priceId = proPrice.priceId;
            proTierPlan.price = formattedPrice;
        }

        priceCache = formattedPrice;
        return priceCache;
    } catch (error) {
        console.error('Error loading pricing:', error);
        throw new Error(PRICING_ERROR_MESSAGE);
    }
};

export const fetchProPrice = () => {
    if (priceCache) {
        return Promise.resolve(priceCache);
    }

    if (!priceRequest) {
        priceRequest = loadProPrice().finally(() => {
            priceRequest = null;
        });
    }

    return priceRequest;
};
